import { RENDERED_FIELDS } from '../config/constants';

// The API names violations after the entity property, in snake case.
const toCamelCase = value => value.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());

// Violations arrive by path (`attachments[0].content`), the form renders the base field. Each
// variant renders its own fields, so a violation on a field it does not show has nowhere to land.
const getRenderedFieldName = (field, recipient) => {
    const [baseField] = String(field || '').split(/[[.]/);
    const renderedField = toCamelCase(baseField);

    return (RENDERED_FIELDS[recipient] || []).includes(renderedField) ? renderedField : null;
};

export default getRenderedFieldName;
